<form-layout [showSave]="canSave" (onSave)="onSaveClick()" (onBack)="onBackClick()" (onNext)="onSaveAndNextClick()"
    (onSubmit)="onSubmitClick()" [showSubmit]="canSubmit" [isSubmitDisabled]="isSubmitDisabled" >
    <form [formGroup]="form" class="d-flex flex-column space-y-4">
        <kendo-formfield class="text" showHints="initial">
            <kendo-label class="form-label" text="{{'aenderungsantrag.kommentar' | translate}} *"
                [infotooltip]="'aenderungsantrag.kommentar'" [for]="kommentar"></kendo-label>
            <kendo-textarea #kommentar formControlName="kommentar" appinfotext="aenderungsantrag.kommentar"
                [attr.aria-label]="'aenderungsantrag.kommentar' | translate"
                [maxlength]="aenderungsantragConfig.KOMMENTAR_MAXLENGTH" [rows]="8"
                [appinfotext]="'aenderungsantrag.kommentar'"
                (paste)="this.textBoxService.onPaste($event, this.form.Kommentar, aenderungsantragConfig.KOMMENTAR_MAXLENGTH)"></kendo-textarea>
        </kendo-formfield>
    </form>
    <form [formGroup]="attachmentProcessStepForm" class="mt-6">
        <attachments formControlName="attachments" [documentTypes]="documentTypes" [AnfrageId]="anfrage.id" [rechtsform]="rechtsform"></attachments>
    </form>
</form-layout>